export enum StarredDisplayModeEnum {
  ShowAllIncludeStarred = "ShowAllIncludeStarred",
  ShowAllWithoutStarred = "ShowAllWithoutStarred",
  FiltersApplied = "FiltersApplied",
  FiltersIgnored = "FiltersIgnored",
}
